import React from "react";
import accessDenied from "../../Assets/Images/403.png"

const AccessDenied = () => {
    return (
        <div className="container">
            <img src={accessDenied} className="w-100" />
        </div>
    )
}

export default AccessDenied